/**
 * @param {number} timeToCompleteTables - Tööaja tabelite täitmisele kuluv aeg kuus h
 * @param {number} timeToAutomaticRegistration - Tööaja automaatsele registreerimistele kuluv aeg kuus h
 * @param {number} financialEffectOfSavingTime -  rahaline efekt registreerimistele kulunud aja kokkuhoiust aastas eur
 *
 * @param {number} lossOfWorkingTime - tööaja kadu hilinemistest kuus täna, h
 * @param {number} timeOfDelays - kontrolli tõhustumisel hilinemiste aeg kuu h
 * @param {number} financialEffectOfRedutionDelays - rahaline efekt hilinemiste vähenemisest aastas
 *
 * @param {number} lossOfWorkingTimeForSmoking - tööaja kadu kuus suitsupausidest  kui 10% töötajaid on täna suitsetajad h  (3 pausi päevas)
 * @param {number} timeOfLossControl - kontrolli tõhustumisel tööaja kadu kuus suitsupausidest  kui 10% töötajaid on täna suitsetajad h (keskmiselt 2,5 pausi päevas)
 * @param {number} financialEffectOfRedutionSmoking - rahaline efekt suitsupausidevähenemisest aastas
 *
 * @param {number} timeForInspection - tööaja kulu kuus kontrollile, aruandlusele, andmetöötlusele
 * @param {number} serviceEfficiencyIncrease - Teeninduse efektiivsus kasvab tänu täpsematele on-line andmetele - kaebuste arv väheneb
 * @param {number} financialEffectOfSimplerControls - rahaline efekt aastas lihtsamast kontrollist, operatiivsest aruandlusest, andmete automaatsest töötlusest
 *
 * @param {number} totalEffect - KOKKU EFEKT SÜSTEEMIST AASTAS
 *
 * @param {number} tottalInvestment - KOKKU investeering tööajaarvestuse süsteemile
 *
 * @param {number} softwareLicenseFee - Tarkvara litsentsi tasu aastas
 *
 * @param {number} oneTerminalPrice - Ühe terminali paigaldus koos juurutamisega
 *
 *
 * @param {number} paybackPeriod - tasuvusaeg, aastat
 */

function calculateAll() {
  //get the main data
  var workers = document.getElementById("workersTable").innerText = document.getElementById("workers").value;
  var salary = document.getElementById("salaryTable").innerText = document.getElementById("salary").value;

  //put const data
  document.getElementById("softwareLicenseFee").innerText = 3000.00 + "€",
      document.getElementById("oneTerminalPrice").innerText = 1500.00 + "€",
      document.getElementById("totalInvestment").innerText = 4500.00 + "€";

  calculateFinancialEffectOfSavingTime(workers, salary);
  calculateFinancialEffectOfRedutionDelays(workers, salary);
  calculateFinancialEffectOfRedutionSmoking(workers, salary);
  calculateFinancialEffectOfSimplerControls(workers, salary);

  calculateTotalEffect();


  document.getElementById("result").innerText = "Tasuvususaeg CompuAccessi kasutusele võtmisel: " +
      (4500 / +calculateTotalEffect()).toFixed(2) + " aastat.";
  document.getElementById("btnShowTable").style.display = "inline";
}

export {calculateAll}

function showTable() {
  document.getElementById("table").style.display = "inline";
  document.getElementById("result").remove();
  document.getElementById("btnCalculate").remove();
  document.getElementById("btnShowTable").remove();
}


function calculateFinancialEffectOfSavingTime(workers, salary) {

  var timeToCompleteTables = document.getElementById("timeToCompleteTables").value = ((12 / 60) * workers).toFixed(2);
  var timeToAutomaticRegistration = document.getElementById("timeToAutomaticRegistration").value = ((6 / 60) * workers).toFixed(2);
  var financialEffectOfSavingTime = document.getElementById("financialEffectOfSavingTime").innerText =
      ((+timeToCompleteTables - +timeToAutomaticRegistration) * (+salary / 168) * 12).toFixed(2);
  return financialEffectOfSavingTime;
}

function calculateFinancialEffectOfRedutionDelays(workers, salary) {

  var lossOfWorkingTime = document.getElementById("lossOfWorkingTime").value = ((10 / 60) * +workers).toFixed(2);
  var timeOfDelays = document.getElementById("timeOfDelays").value = ((5 / 60) * workers).toFixed(2);
  var financialEffectOfRedutionDelays = document.getElementById("financialEffectOfRedutionDelays").innerText =
      (((+lossOfWorkingTime - +timeOfDelays) * (salary / 168)) * 12).toFixed(2);
  return financialEffectOfRedutionDelays;
}

function calculateFinancialEffectOfRedutionSmoking(workers, salary) {
  var lossOfWorkingTimeForSmoking = document.getElementById("lossOfWorkingTimeForSmoking").value = (((3 * 10) / 60) * (+workers * 0.1)).toFixed(2);
  var timeOfLossControl = document.getElementById("timeOfLossControl").value = (((2 * 10) / 60) * (+workers * 0.1)).toFixed(2);
  var financialEffectOfRedutionSmoking = document.getElementById("financialEffectOfRedutionSmoking").innerText =
      ((+lossOfWorkingTimeForSmoking - +timeOfLossControl) * (+salary / 168) * 12).toFixed(2);
  return financialEffectOfRedutionSmoking;
}

function calculateFinancialEffectOfSimplerControls(workers, salary) {
  var timeForInspection = document.getElementById("timeForInspection").value = ((20 / 60) * +workers).toFixed(2);
  var serviceEfficiencyIncrease = document.getElementById("serviceEfficiencyIncrease").value = ((16 / 60) * +workers).toFixed(2);
  var financialEffectOfSimplerControls = document.getElementById("financialEffectOfSimplerControls").innerText =
      (((+timeForInspection - +serviceEfficiencyIncrease) * (+salary / 168)) * 12).toFixed(2);
  return financialEffectOfSimplerControls;
}

function calculateTotalEffect() {
  var totalEffect = (+document.getElementById("financialEffectOfSavingTime").textContent + +document.getElementById("financialEffectOfRedutionDelays").textContent +
      +document.getElementById("financialEffectOfRedutionSmoking").textContent + +document.getElementById("financialEffectOfSimplerControls").textContent).toFixed(2);
  document.getElementById("totalEffect").innerText = totalEffect;
  document.getElementById("paybackPeriod").innerText = (4500 / +totalEffect).toFixed(2);

  return totalEffect;
}


